"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Network_1 = __importDefault(require("../../interface/Network"));
const Token_1 = __importDefault(require("../../interface/Token"));
const Handler_1 = __importDefault(require("../../interface/Handler"));
const Method_1 = __importDefault(require("../../interface/Method"));
const EntryPoint_1 = __importDefault(require("../../interface/EntryPoint"));
exports.default = new Network_1.default('avalanche', [
    new Token_1.default('avax', 'AVAX', 'bifi', 0, '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE', '', false, false, false, [], '{} AVAX', 'icon/avax.svg'),
    new Token_1.default('weth.e', 'WETH.e', 'bifi', 1, '0x49D5c2BdFfac6CE2BFdB6640F4F80f226bc10bAB', '', false, true, false, [], '{} WETH.e', 'icon/ether.svg'),
    new Token_1.default('usdt.e', 'USDT.e', 'bifi', 2, '0xc7198437980c041c805A1EDcbA50c1Ce5db95118', '', false, true, false, [], '{} USDT.e', 'icon/usdt.svg'),
    new Token_1.default('usdc.e', 'USDC.e', 'bifi', 3, '0xA7D7079b0FEaD91F3e65f86E8915Cb59c1a4C664', '', false, true, false, [], '{} USDC.e', 'icon/usdc.svg'),
    new Token_1.default('dai.e', 'DAI.e', 'bifi', 4, '0xd586E7F844cEa2F87f50152665BCbc2C279D8d70', '', false, true, false, [], '{} DAI.e', 'icon/dai.svg'),
    new Token_1.default('wbtc.e', 'WBTC.e', 'bifi', 5, '0x50b7545627a5162F82A992c33b87aDc75187B218', '', false, true, false, [], '{} WBTC.e', 'icon/wbtc.svg'),
    new Token_1.default('bifi', 'BiFi', '', -1, '0x3C1BB39bb696B443a1D80BB2b3a3d950Ba9DEE87', '', false, true, false, [], '{} BiFi', 'icon/bifi.svg')
], [
    new Handler_1.default(0, 'avax'),
    new Handler_1.default(1, 'weth.e'),
    new Handler_1.default(2, 'usdt.e'),
    new Handler_1.default(3, 'usdc.e'),
    new Handler_1.default(4, 'dai.e'),
    new Handler_1.default(5, 'wbtc.e')
], [
    new Method_1.default('bifi.market', 'callProxyMarket_getMarket()', [], [
        '(uint256,address,uint256,uint256,uint256,uint256,uint256)[]',
        'bool'
    ]),
    new Method_1.default('bifi.user', 'callProxyUser_getUser(address)', ['user.address'], [
        '(uint256,address,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256)[]',
        '(uint256,uint256,uint256,uint256)'
    ]),
    new Method_1.default('bifi.si', 'callProxySI_getSI(address)', ['user.address'], [
        'address',
        '(uint256,uint256,uint256,uint256,uint256,uint256)[]',
        '(uint256,uint256,uint256,uint256)',
        'uint256'
    ]),
    new Method_1.default('bifi.circuitBreak', 'callProxyManager_getCircuitBreaker()', [], ['bool']),
    new Method_1.default('xBifi.maxBoost', 'getMaxBoost(uint256)', ['handlerID'], ['uint256']),
    new Method_1.default('xBifi.startPosition', 'getStartPosition(uint256,uint256,uint256,uint256,uint256,address,uint256)', [
        'srcHandlerID',
        'dstHandlerID',
        'collateralAmount',
        'times',
        'slippage',
        'user.address',
        'bifiAmount'
    ], ['(uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256)']),
    new Method_1.default('xBifi.positionNFTs', 'getAllPositionNFT(address)', ['user.address'], ['(uint256,address,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256)[]']),
    new Method_1.default('xBifi.claim', 'getClaimableBifi(address)', ['address'], ['uint256']),
    new Method_1.default('xBifi.endPosition', 'getEndPosition(address,uint256,uint256)', [
        'address',
        'slippage',
        'bifiAmount'
    ], ['(uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256)']),
    new Method_1.default('xBifi.oracle', 'getOracle()', [], [
        'uint256[]',
        'uint256[]',
        'uint256[]'
    ]),
    new Method_1.default('xBifi.amountsOfOut', 'getAmountsOut(uint,uint256[2])', [
        'amountIn',
        'tokenIDs'
    ], ['uint'])
], [
    new EntryPoint_1.default('bifi', '0x66dc86619Bc07B36A39b2eBD37b11b29c83949eD'),
    new EntryPoint_1.default('xBifi', '0xc8B2B6840A95AE5f40a5Ac3AE6be427Fcd3F7b8B'),
    new EntryPoint_1.default('xBifi.factory', '0xc7C00d318D5fC2e16565650121bB0d422566514c')
], 5000);
//# sourceMappingURL=avalanche.js.map